// extracted by mini-css-extract-plugin
export default {"mailButton":"MailButton_mailButton__ivwPe","icon":"MailButton_icon__gOJk6"};